import React ,{useEffect, useState}from 'react'
import './Rowpost.css'
import axios from '../../axios'
import { imageUrl } from '../../constants/Constants'
import Youtube from 'react-youtube'
import { API_KEY } from '../../constants/Constants'

function Rowpost(props) {
  const [movies, setMovies] = useState([])
  const [urlid,seturlId]=useState('')
  useEffect(() => {
    axios.get(props.url).then((response)=>{
      console.log(response.data)
      setMovies(response.data.results)
    })

  }, [])

  const opts = {
    height: '390',
    width: '100%',
    playerVars: {
      // https://developers.google.com/youtube/player_parameters
      autoplay: 1,
    },
  };

  const handleMovieTrailer = (id) =>{
    console.log(id)
    axios.get(`movie/${id}/videos?api_key=${API_KEY}&language=en-US`).then((response)=>{
      if(response.data.results.length!==0){
        seturlId(response.data.results[0])
      }else{
        console.log('Trailer not available')
      }
    })

  }
  
  return (
    <div className='row'>
        <h2 className='titlemovie'>{props.title}</h2> 
        <div className='posters'>
          {movies.map((obj)=>{
            return (
              <div key={obj.id} className="poster-container">
              <img
                onClick={() => handleMovieTrailer(obj.id)}
                className={props.isSmall ? 'smallposter' : 'poster'}
                src={`${imageUrl + obj.backdrop_path}`}
                alt={obj.title || obj.name}
              />
              <p className="movie-title">{obj.title || obj.name}</p>
            </div>
            )

 } )}
            </div>    
          { urlid &&   <Youtube opts={opts} videoId={urlid.key}  />}
    </div>
  )
}

export default Rowpost
